import React, { Component } from 'react';
import { Badge } from 'react-bootstrap';

import PrefacturaStatus from '../../support/enum/PrefacturaStatus';

class PrefacturaStatusBadge extends Component {

  get config() {
    const { status } = this.props;

    const prefactura = PrefacturaStatus.search(status);

    let variant = '';
    let text = '';

    if (prefactura.isPending()) {
      variant = 'warning';
      text = 'Pendiente';
    } else if (prefactura.isCancelled()) {
      variant = 'danger';
      text = 'Cancelado';
    } else if (prefactura.isSuccess()) {
      variant = 'success';
      text = 'Timbrado';
    }

    return {
      variant,
      text
    }
  }

  render() {
    const { variant, text } = this.config;

    return (
      <Badge pill variant={ variant }>
        { text }
      </Badge>
    )
  }
}

export default PrefacturaStatusBadge;